import { IconMap } from '../../../shared/sprite';
import { DEFAULT_SORT_ITEMS } from '../../../shared/ui/select';

export enum SnippetsTab {
  TEAM = 'team',
  PERSONAL = 'personal',
  DRAFTS = 'drafts',
}

export const SORT_ITEMS = {
  lastCreated: DEFAULT_SORT_ITEMS.lastCreated,
  mostPopular: { glyph: IconMap.Star, label: 'Most popular' },
  name: DEFAULT_SORT_ITEMS.name,
} as const;

export const SNIPPET_NO_FOUND_MESSAGES = {
  teamSnippetsCategoryManager: {
    title: 'No snippets found',
    description: 'Begin by establishing categories of snippets for your team.',
  },
  teamSnippetsManager: {
    title: 'No snippets found',
    description: 'Tailor snippets to suit your specific needs.',
  },
  teamSnippetsMember: {
    title: 'No snippets found',
    description: 'Wait for the team admin(s) to set up snippets for your team.',
  },
  personal: {
    title: 'No snippets found',
    description: 'Tailor snippets to suit your specific needs.',
  },
  drafts: {
    title: 'No drafts found',
    description: 'Create snippets to streamline your workflow.',
  },
} as const;
